import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetB2BConfigurationsResponse } from '@/api/agency/get-b2b-configurations'

export const mockGetB2BConfigurations = http.get(
  '/my-business/api/agency/v1/company-infos/:agencyChainAlphaId/codes',
  () => {
    const response: GetB2BConfigurationsResponse = {
      code: faker.string.numeric(5),
      chainCode: faker.string.numeric(5),
    }

    return HttpResponse.json(response, { status: 200 })
  },
)
